export type CustomerRoute = {
  path: string;
  breadcrumb: string;
};

export const CUSTOMER_ROUTES = {
  home: { path: '/', breadcrumb: 'Úvod' },
  booking: { path: 'booking', breadcrumb: 'Rezervace' },
  login: { path: 'login', breadcrumb: 'Přihlášení' },
  setPin: { path: 'set-pin', breadcrumb: 'Nastavení PINu' },
  resetPin: { path: 'reset-pin', breadcrumb: 'Obnovení PINu' },
  deviceLink: {
    path: 'device-link',
    breadcrumb: 'Propojení zařízení',
  },
  browserGuide: {
    path: 'browser-guide',
    breadcrumb: 'Návod k prohlížeči',
  },
} as const;

export const CustomerPaths = {
  home: (): string => CUSTOMER_ROUTES.home.path,
  booking: (): string => CUSTOMER_ROUTES.booking.path,
  login: (): string => CUSTOMER_ROUTES.login.path,
  deviceLink: (): string => CUSTOMER_ROUTES.deviceLink.path,
  browserGuide: (): string => CUSTOMER_ROUTES.browserGuide.path,
};
